import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.WalletsTabActions', {
    send: 'Send',
    addFunds: 'Add funds',
    convert: 'Convert',
    fundingNotAvailable: 'Funding is not available.',
});
